import { getCompanies } from '@/dataProvider/filtersDataProvider/getCompanies';
import { getFilters } from '@/dataProvider/filtersDataProvider/getFilters';
import { getCohorts } from '@/dataProvider/filtersDataProvider/getCohorts';

export const filtersDataProvider = {
  getCompanies: getCompanies,
  getFilters: getFilters,
  getCohorts: getCohorts,
};
